import styled from '@emotion/styled';
import {css} from '@emotion/react';

export const SignInErrorMessage = styled.p`
  ${({theme}) => css`
    color: ${theme.colors.red};
    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.weight.normal};
    text-align: center;
  `}
`;

export const ForgotPasswordLink = styled.span`
  ${({theme}) => css`
    color: ${theme.colors.gray4};
    font-size: ${theme.font.sizes.xsmall};
    font-weight: ${theme.font.weight.bold};
    transition: opacity ${theme.transition.default};
    text-decoration: none;
    text-align: right;
    a {
      color: currentColor;
    }

    &:hover {
      opacity: 0.75;
    }
  `}
`;

export const TextFieldWithTextWarpper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
